<template>
  <v-container data-testid="approvalsPage-container" fluid>
    <HeaderRoutinePrint
      data-testid="approvalsPage-headerRoutinePrint"
      :routineExecution="routineExecution"
    />
    <DetailRoutinePrint
      data-testid="approvalsPage-detailRoutinePrint"
      :checklistItems="checklistItems"
      :routineExecution="routineExecution"
    />
    <div
      class="d-flex justify-center"
      data-testid="approvalsPage-container-sectionTitle"
    >
      <span
        class="pa-0 my-4 body-2 font-weight-bold blue-grey--text text--darken-3"
        data-testid="approvalsPage-text-sectionTitle"
      >
        {{ $t('routines.approval.approvals_tab_title') }}
      </span>
    </div>

    <div data-testid="approvalsPage-container-list">
      <div
        v-for="approval in approvals"
        :key="approval.id"
        class="d-flex justify-start flex-column mb-6"
        data-testid="approvalsPage-row-approval"
      >
        <p
          class="caption font-weight-bold blue-grey--text text--darken-3 pa-0 my-0 mr-1"
          data-testid="approvalsPage-text-approvedBy"
        >
          {{ `${$t('routines.approvals_table.approved_by')}:` }}
          <span class="caption blue-grey--text text--darken-3">
            {{ formatApprover(approval.approver) }}
          </span>
        </p>

        <p
          class="caption font-weight-bold blue-grey--text text--darken-3 pa-0 my-0 mr-1"
          data-testid="approvalsPage-text-approvedAt"
        >
          {{ `${$t('routines.approval.approved_on')}:` }}
          <span class="caption blue-grey--text text--darken-3">
            {{ formatApprovalDate(approval.statusUpdatedAt) }}
          </span>
        </p>

        <p
          v-if="hasNotes(approval.notes)"
          class="caption font-weight-bold blue-grey--text text--darken-3 pa-0 my-0 mr-1 mb-1"
          data-testid="approvalsPage-text-notes"
        >
          {{ `${$t('routines.approvals_table.notes')}:` }}
          <span
            class="caption blue-grey--text text--darken-3 pre-line font-weight-regular"
          >
            {{ getTrimmedNotes(approval.notes) }}
          </span>
        </p>
      </div>
    </div>
  </v-container>
</template>

<script>
import { utils } from 'frontend-js-shared'

import mixin from '@/mixins/mixin.vue'

import DetailRoutinePrint from './DetailRoutinePrint.vue'
import HeaderRoutinePrint from './HeaderRoutinePrint.vue'

export default {
  name: 'ApprovalsPage',

  components: {
    DetailRoutinePrint,
    HeaderRoutinePrint,
  },

  mixins: [mixin],

  props: {
    approvals: {
      type: Array,
      default: () => [],
    },
    checklistItems: {
      type: Array,
      default: () => [],
    },
    routineExecution: {
      type: Object,
      required: true,
    },
    totalPages: {
      type: Number,
      default: 0,
    },
  },

  methods: {
    formatApprovalDate(date) {
      if (!date) return ''

      return utils.dates.formatDate(date, 'MMM D YYYY, h:mm A')
    },

    formatApprover(approver) {
      const fullName = this.getFullName(approver)
      const email = approver?.email ?? ''

      if (fullName && email && fullName !== email) {
        return `${fullName} <${email}>`
      }

      return fullName || email
    },

    getTrimmedNotes(notes) {
      return (notes ?? '').trim()
    },

    hasNotes(notes = '') {
      return this.getTrimmedNotes(notes).length > 0
    },
  },
}
</script>
